import React from "react";
import styled, { keyframes } from "styled-components";

export default function Skeleton() {
  return (
    <Bg>
      <SkeletonStyle></SkeletonStyle>
    </Bg>
  );
}

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const Bg = styled.div`
  background: #0000005d;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  height: 100vh;
  overflow: hidden;
  overflow-y: scroll;
  display: grid;
  place-items: center;
  padding: 40px 0;
`;

const SkeletonStyle = styled.div`
  margin: 0 auto;
  animation: ${rotate360} 1s linear infinite;
  border-top: 6px solid #fff;
  border-right: 6px solid #fff;
  border-bottom: 6px solid #fff;
  border-left: 6px solid #ff993a;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) translateZ(0);
  background: transparent;
  width: 200px;
  height: 200px;
  border-radius: 50%;
`;
